export default "__VITE_ASSET__BEJqyuTu__"